import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Informacao from './Informacao';
import CardFestiveDate from './CardFestiveDate';
import { Grid } from '@material-ui/core';
import Calendario from './Calendario';

const ContainerCalendario = () => {
  const diaAtual = new Date().getDate();
  const [feriados, setFeriados] = useState([]);
  const [mesAtual, setMesAtual] = useState(new Date().getMonth() + 1);
  const [anoAtual, setAnoAtual] = useState(new Date().getFullYear());
  const [markedDay, setMarkedDay] = useState(
    `${diaAtual}-${mesAtual}-${anoAtual}`
  );
  const [diasVazios, setDiasVazios] = useState([]);

  const styles = {
    festivedate: {
      padding: '10px 24px'
    }
  };

  const fetchFeriados = async (ano) => {
    const apiUrl = `https://brasilapi.com.br/api/feriados/v1/${ano}`;
    try {
      const response = await axios.get(apiUrl);
      setFeriados(response.data);
    } catch (error) {
      console.error('Erro ao buscar os dados da API:', error);
    }
  };

  function converterFeriados(diaMesAno) {
    var partes = diaMesAno.split('-');
    if (partes.length !== 3) {
      return 'Formato de data inválido. Use o formato dia-mês-ano (dd-mm-yyyy).';
    }
    var dia = partes[0];
    var mes = partes[1] < 10 ? `0${partes[1]}` : partes[1];
    var ano = partes[2];
    return ano + '-' + mes + '-' + dia;
  }

  const filterFeriados = (feriado) => {
    if (markedDay && markedDay.split('-')[1] == mesAtual) {
      if (feriado.date == converterFeriados(markedDay)) {
        return true;
      }
    } else {
      const mesFeriado = feriado.date.split('-')[1];
      if (mesAtual == mesFeriado) {
        return true;
      }
    }
  };

  useEffect(() => {
    const primeiroDiaSemana = new Date(anoAtual, mesAtual - 1, 1).getDay();
    setDiasVazios(Array(primeiroDiaSemana).fill(null));
  }, [anoAtual, mesAtual]);

  useEffect(() => {
    fetchFeriados(anoAtual);
  }, [anoAtual]);

  return (
    <Grid container spacing={6}>
      <Grid item md={5} sm={6} xs={12} container>
        <Calendario
          setFeriados={setFeriados}
          diaAtual={diaAtual}
          mesAtual={mesAtual}
          setMesAtual={setMesAtual}
          anoAtual={anoAtual}
          setAnoAtual={setAnoAtual}
          markedDay={markedDay}
          setMarkedDay={setMarkedDay}
          diasVazios={diasVazios}
          setDiasVazios={setDiasVazios}
        />
      </Grid>
      <Grid item md={7} sm={6} xs={12}>
        <Informacao />
      </Grid>
      <Grid container spacing={6} style={styles.festivedate}>
        {feriados
          .filter((feriado) => filterFeriados(feriado))
          .map((feriado, index) => (
            <Grid item xs={12} sm={6} md={4}>
              <CardFestiveDate
                key={index}
                date={feriado.date}
                name={feriado.name}
                color={'#E4ECF5'}
              />
            </Grid>
          ))}
      </Grid>
    </Grid>
  );
};

export default ContainerCalendario;
